const initialState = { itens: [] }

export default function cart(state = initialState, action) {
  switch (action.type) {
    case 'ADD_TO_CART':
      if (!action.item.codipro) {
        return state
      }

      let produtoNoCarrinho_add = state.itens.findIndex(
        (item, index, array) => item.codipro === action.item.codipro
      )
      if (produtoNoCarrinho_add >= 0) {
        return {
          ...state,
          itens: state.itens.map((item) => {
            item.codipro === action.item.codipro &&
              (item.qtde = item.qtde + action.item.qtd)
            return item
          }),
        }
      } else {
        return {
          ...state,
          itens: [...state.itens, { ...action.item, qtde: action.item.qtd }],
        }
      }

    case 'SUBTRACT_FROM_CART':
      return {
        ...state,
        itens: state.itens.map((item) => {
          item &&
            item.codipro === action.item.codipro &&
            item.qtde > 0 &&
            item.qtde--
          return item
        }),
      }

    case 'REMOVE_FROM_CART':
      return {
        ...state,
        itens: state.itens.filter(
          (item) => item.codipro !== action.item.codipro
        ),
      }

    case 'CLEAR_CART':
      return initialState

    default:
      return state
  }
}
